// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

ngx-monaco-editor {
  object-fit: fill;
  height: calc(100vh - 100px) !important;
}

.progress {
  margin-bottom: 5px;
  font-size: 15px;
}

.save-error {
  margin-bottom: 5px;
  font-size: 15px;
  color: red;
}

a.save-error {
  text-decoration: none;
}

a.save-error:hover {
  -webkit-text-decoration: under;
          text-decoration: under;
}

.isDisabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
  text-decoration: none;
}

.new {
  font-style: italic;
  color: rgba(0, 0, 0, 0.5);
}

.fix-padding {
  padding: 0.6em 0 0 0 !important;
}

.tags-list {
  width: 100%;
}

.fix-align {
  margin-left: -4px;
  text-align: left;
}

form {
  box-sizing: border-box;
  min-width: 430px;
}
form:not(.no-padding) {
  padding: var(--content-margin);
}

.mat-drawer-container {
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.panel-head {
  width: 100%;
  padding: 4px;
  text-align: center;
  font-family: var(--font-mono);
}

.divider {
  height: 10px;
}

textarea {
  width: 419px;
  height: 444px;
  margin-top: 10px;
}

.progress-column {
  display: flex;
  flex-direction: column;
}

.progress-bar-row {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}

.progress-text-row {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  font-size: 11pt;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.success-row {
  display: flex;
  flex-direction: row;
}

.success-text {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  font-size: 11pt;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.success {
  color: green;
  display: flex;
  flex-direction: column;
  margin-right: 3px;
}

.component-buttons {
  padding: 0 var(--content-margin) var(--content-margin);
}

mat-icon.smol {
  height: 18px;
  width: 18px;
  font-size: 18px;
}

button.smol {
  min-height: 36px;
  --mat-menu-item-label-text-size: 14px;
}

mat-drawer-container {
  height: 100%;
  width: 100%;
}

:host {
  display: flex;
  flex-grow: 1;
  height: 100%;
  width: 100%;
}

.mat-drawer-container {
  height: 100%;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.content {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.gridster-item {
  min-height: 100%;
  min-width: 100%;
  display: flex;
}

svg {
  width: 100% !important;
  height: 100% !important;
  overflow: visible;
}

.error-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 24px;
  margin: 16px;
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 8px;
}
.error-container mat-icon {
  color: #f44336;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.error-container .error-message strong {
  display: block;
  margin-bottom: 8px;
  color: #f44336;
}
.error-container .error-message p {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 13px;
  opacity: 0.9;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/workflow-widget/workflow-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,8BAAA;UAAA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;AACF;AACE;EACE,8BAAA;AACJ;;AAGA;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,sDAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,qCAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,kCAAA;EACA,wCAAA;EACA,kBAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAII;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAFN;AAKI;EACE,SAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAHN","sourcesContent":[".content {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n\nngx-monaco-editor {\n  object-fit: fill;\n  height: calc(100vh - 100px) !important;\n}\n\n.progress {\n  margin-bottom: 5px;\n  font-size: 15px;\n}\n\n.save-error {\n  margin-bottom: 5px;\n  font-size: 15px;\n  color: red;\n}\n\na.save-error {\n  text-decoration: none;\n}\n\na.save-error:hover {\n  text-decoration: under;\n}\n\n.isDisabled {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.5;\n  text-decoration: none;\n}\n\n.new {\n  font-style: italic;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.fix-padding {\n  padding: 0.6em 0 0 0 !important;\n}\n\n.tags-list {\n  width: 100%;\n}\n\n.fix-align {\n  margin-left: -4px;\n  text-align: left;\n}\n\nform {\n  box-sizing: border-box;\n  min-width: 430px;\n\n  &:not(.no-padding) {\n    padding: var(--content-margin);\n  }\n}\n\n.mat-drawer-container {\n  height: 100%;\n  user-select: none;\n}\n\n.panel-head {\n  width: 100%;\n  padding: 4px;\n  text-align: center;\n  font-family: var(--font-mono);\n}\n\n.divider {\n  height: 10px;\n}\n\ntextarea {\n  width: 419px;\n  height: 444px;\n  margin-top: 10px;\n}\n\n.progress-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.progress-bar-row {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.progress-text-row {\n  display: flex;\n  flex-direction: row;\n  margin-top: 5px;\n  font-size: 11pt;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.success-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.success-text {\n  display: flex;\n  flex-direction: column;\n  margin-top: 5px;\n  font-size: 11pt;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.success {\n  color: green;\n  display: flex;\n  flex-direction: column;\n  margin-right: 3px;\n}\n\n.component-buttons {\n  padding: 0 var(--content-margin) var(--content-margin);\n}\n\nmat-icon.smol {\n  height: 18px;\n  width: 18px;\n  font-size: 18px;\n}\n\nbutton.smol {\n  min-height: 36px;\n  --mat-menu-item-label-text-size: 14px;\n}\n\nmat-drawer-container {\n  height:100%;\n  width:100%;\n}\n\n:host {\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n  width: 100%;\n}\n\n.mat-drawer-container {\n  height: 100%;\n  width: 100%;\n  user-select: none;\n}\n\n.content {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.gridster-item {\n  min-height: 100%;\n  min-width: 100%;\n  display: flex;\n}\n\nsvg {\n  width: 100% !important;\n  height: 100% !important;\n  overflow: visible;\n}\n\n.error-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 24px;\n  margin: 16px;\n  background: rgba(244, 67, 54, 0.1);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 8px;\n\n  mat-icon {\n    color: #f44336;\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  .error-message {\n    strong {\n      display: block;\n      margin-bottom: 8px;\n      color: #f44336;\n    }\n\n    p {\n      margin: 0;\n      font-family: var(--font-mono);\n      font-size: 13px;\n      opacity: 0.9;\n      word-break: break-word;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
